import React, { useEffect, useState } from "react";
import API from "../utils/API";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from '@material-ui/data-grid';

function CustomToolbar() {
  return (
    <GridToolbarContainer  >
      <GridToolbarExport variant="contained" color="secondary"/>
    </GridToolbarContainer>
  );
}

const Notinterested = () => {
  const history = useHistory();

  const [notinterested, setnotinterested] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateFromButtonClick, setStartDateFromButtonClick] = useState();
  const [endDateFromButtonClick, setEndDateFromButtonClick] = useState();

  const [loading, setLoading] = useState(false);

  const options = { month: "long", day: "numeric", year: "numeric" };

  const dateFormatter = new Intl.DateTimeFormat("en-GB", options);

  const columns = [
    { field: "id", headerName: "Id", width: 100 },
    {
      field: "issueType",
      headerName: "Response",
      width: 200,
      valueFormatter: (value) => value.row?.issueType?.name,
    },
    { field: "customerNumber", headerName: "Customer Number", width: 250 },
    {
      field: "createdAt",
      headerName: "Creation Date",
      width: 150,
      valueFormatter: ({ value }) => dateFormatter.format(new Date(value)),
    },
    {
      field: "createdPerson",
      headerName: "Created By",
      width: 150,
      valueFormatter: (value) => value.row?.createdPerson?.name,
    },
    { field: "remarks", headerName: "Remarks", width: 1000 },
  ];

  const handleClick = () => {
    setLoading(!loading);
    setStartDateFromButtonClick(startDate);
    setEndDateFromButtonClick(endDate);
    setnotinterested({});
  };

  useEffect(() => {
    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

    var today = new Date();

    let month = today.getMonth() + 1;
    let year = today.getFullYear();

    let lastdate = daysInMonth(today.getMonth() + 1, today.getFullYear());
    if (month !== 10 && month !== 11 && month !== 12) {
      month = `0${month}`;
    }
    console.log(month);
    console.log(year);
    console.log(lastdate);
    const start = `${year}-${month}-01`;
    const end = `${year}-${month}-${lastdate}`;
    console.log(start);
    console.log(end);

    setStartDate(start);
    setEndDate(end);
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("tokenStore");

    if (!storedToken) {
      history.push("/");
    }
    if (startDate !== "" && endDate !== "") {
      API({
        url: `/notinterested?startDate=${startDateFromButtonClick}&endDate=${endDateFromButtonClick}`,
        headers: { Authorization: `Bearer ${storedToken}` },
      })
        .then((res) => {
          setLoading(false);
          console.log(res);
          console.log(res.data);
          setnotinterested(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [startDateFromButtonClick, endDateFromButtonClick, loading]);

  const mapToId = (notinterested) =>
    notinterested.map((row) => {
      const { issueId, ...rest } = row;
      return { id: issueId, ...rest };
    });

    

  return (
    <Box alignItems="center" style={{ width: "87%", marginLeft: "15rem" }}>
      <div>
        <form noValidate onSubmit={(e) => e.preventDefault()}>
          <TextField
            onChange={(e) => setStartDate(e.target.value)}
            id="datetime-local"
            label="Start Date"
            type="date"
            value={startDate}
            style={{ transform: "translate(-15%,-20%)" }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            onChange={(e) => setEndDate(e.target.value)}
            id="datetime-local"
            label="End Date"
            type="date"
            value={endDate}
            style={{ transform: "translate(8%,-20%)" }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <br />
          <Button
            type="submit"
            style={{
              padding: "4px",
              margin: "5px",
              marginTop: "20px",
            }}
            variant="contained"
            color="primary"
            onClick={handleClick}
          >
            Submit
          </Button>
        </form>

        <br />

        <div
          style={{
            height: 400,
            width: "90%",
            background: "transparent",
            color: "black",
            marginTop: 20,
            marginLeft: 10,
          }}
        >
          {notinterested.length > 0 && (
            <DataGrid
              rows={mapToId(notinterested)}
              columns={columns}
              pageSize={10}
              sortingOrder={["asc", "desc"]}
              sortModel={[
                {
                  field: "id",
                  sort: "desc",
                },
              ]}
              components={{
              Toolbar: CustomToolbar,
              }}
            />
          )}

          {loading ? <CircularProgress style={{ marginTop: 50 }} /> : ""}
        </div>
      </div>
    </Box>
  );
};

export default Notinterested;
